import React, { useEffect, useState } from 'react';
import Menu from '../../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Swal from 'sweetalert2'
import CurrencyInput from 'react-currency-input';
import InputMask from 'react-input-mask';
import moment from 'moment';
import { criaTransmissao, atualizaTransmissao, buscaTransmissao, listaUsuarios, listaSalaVip, criaSalaVip, deletaSalaVipFull, criaCupom, listaCupom, deletaCupom, buscaAtletaIndicacao as buscaAtletaPorCpf, listaIndicacoes, criaIndicacao, deletaIndicacao } from '../../../services/mysql'
import UsuarioSelect from './UsuarioSelect';
import { cpf } from 'cpf-cnpj-validator';

export default function CadastroProdutos(props) {
    const [dados] = useState(props.location.state ? props.location.state.produto : '')
    const queryParams = new URLSearchParams(window.location.search);
    const [id] = useState(queryParams.get('i'))
    const [usuarios, setUsuarios] = useState([])
    const [salaVip, setSalaVip] = useState([])


    // Dados Academia
    const [imagem, setImagem] = useState('')
    const [nomeAcademia, setNomeAcademia] = useState('')
    const [canalTransmissao, setCanalTransmissao] = useState('')
    const [dataTransmissao, setDatalTransmissao] = useState('')
    const [status, setStatus] = useState('')
    const [free, setFree] = useState(false)
    const [indicacoesAtivas, setIndicacoesAtivas] = useState(false)
    const [valor, setValor] = useState(0)
    const [qtdConvidados, setQtdConvidados] = useState(0)

    // Sala Vip
    const [usuario, setUsuario] = useState({})

    // Indicações por atleta
    const [cpfAtleta, setCpfAtleta] = useState('')
    const [mensagemBuscaAtleta, setMensagemBuscaAtleta] = useState('')
    const [atletaEncontrado, setAtletaEncontrado] = useState(null)
    const [indicacoes, setIndicacoes] = useState([])
    const [buscandoAtleta, setBuscandoAtleta] = useState(false)
    const [adicionandoAtleta, setAdicionandoAtleta] = useState(false)
    const [removendoIndicacao, setRemovendoIndicacao] = useState(null)
    const [carregandoIndicacoes, setCarregandoIndicacoes] = useState(true)
    const [erroIndicacoes, setErroIndicacoes] = useState('')

    // Cupons
    const [listaCupons, setListaCupons] = useState([])
    const [nomeCupom, setNomeCupom] = useState('')
    const [emailCupum, setEmailCupom] = useState('')
    const [qtdCupum, setQtdCupom] = useState(0)
    const [cpfCupom, setCpfCupom] = useState('')
    const [valorCupom, setValorCupom] = useState(0)

    useEffect(() => {
        if (id) {
            carregarIndicacoes()
            mensagemLoading('Carregando dados..')
            buscaTransmissao(id).then((res) => {
                if (res.erro) {
                    mensagemErro('Erro ao buscar transmissão')
                } else {
                    setImagem(res.transmissao.urlImagem)
                    setNomeAcademia(res.transmissao.nome)
                    setCanalTransmissao(res.transmissao.canalTransmissao)
                    setDatalTransmissao(res.transmissao.dataTransmissao)
                    setValor(res.transmissao.valor)
                    setStatus(res.transmissao.status)
                    setFree(res.transmissao.free)
                    setIndicacoesAtivas(res.transmissao.indicacoes === true || Number(res.transmissao.indicacoes) === 1)
                    Swal.close()
                }
            })
            listaCupom(id).then((res) => {
                if (res.sucesso) {
                    console.log(res.dados)
                    setListaCupons(res.dados)
                }
            })
            if (id) {
                listaUsuarios().then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao buscar usuarios')
                    } else {
                        setUsuarios(res)
                    }
                })
                listaSalaVip({ tipo: 'transmissao', id: id }).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao buscar sala vip')
                    } else {
                        setSalaVip(res)
                        console.log(res)
                    }
                })
            }
        }

    }, [])

    function cadastraEvento() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        if (!nomeAcademia) {
            mensagemAlerta('Digite o nome da Academia')
            return
        }
        if (!canalTransmissao) {
            mensagemAlerta('Coloque o canal da transmissão')
            return
        }
        if (!status) {
            mensagemAlerta('Escolha o status da academia')
            return
        }
        if (!free) {
            mensagemAlerta('Escolha se a transmissão vai ser Free ou não')
            return
        }
        if ((!valor || valor === 0) && free === 'NAO') {
            mensagemAlerta('Digite o valor da transmissão')
            return
        }
        const data = {
            idProdutor: user.id,
            urlImagem: imagem,
            nome: nomeAcademia,
            canalTransmissao: canalTransmissao,
            dataTransmissao: dataTransmissao,
            valor: valor,
            status: status,
            free:free,
            indicacoes: indicacoesAtivas
        }
        console.log(data)
        if (id) {
            mensagemLoading('Atualizando transmissão..')
            atualizaTransmissao(id, data).then((res) => {
                if (res.erro) {
                    mensagemErro(res.message)
                } else {
                    mensagemSucesso(res.message)
                }
            })
        } else {
            mensagemLoading('Cadastrando transmissão..')
            criaTransmissao(data).then((res) => {
                if (res.erro) {
                    console.log(res)
                    mensagemErro('Erro ao cadastrar transmissão')
                } else {
                    mensagemSucesso(res.message)
                }
            })
        }

    }

    function cadastraSala() {
        if (!usuario.id) {
            mensagemAlerta('Selecione um usuário')
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: `Deseja adicionar o usuário ${usuario.nome} a sala VIP desta transmissão ? Ele(a) terá ${qtdConvidados} convidados para adicionar para acompanhar a transmissão.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Cadastrando usuário a sala VIP')
                const data = {
                    idUsuario: usuario.id,
                    idSala: id,
                    tipo: 'transmissao',
                    qtdConvidados: parseInt(qtdConvidados)
                }
                criaSalaVip(data).then((res) => {
                    if (res.erro) {
                        mensagemAlerta(res.msg)
                    } else {
                        mensagemSucessoSalaVip(res.message)
                    }
                })
            }
        });
    }

    function removeSala(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o usuário ' + item.usuarioNome + ' da sala VIP desta transmissão  ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Removendo usuário da sala VIP')
                const data = {
                    idUsuario: item.usuarioId,
                    idSala: id,
                    tipo: 'transmissao'
                }
                deletaSalaVipFull(data).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao cadastrar usuário na sala vip')
                    } else {
                        mensagemSucessoSalaVip('Usuário adicionado a sala vip com sucesso!')
                    }
                })
            }
        });
    }


    // Cupons
    function cadastraCupom() {
        if (!nomeCupom) {
            mensagemAlerta('Digite o nome do usuário ')
            return
        }
        if (!cpf.isValid(cpfCupom.replace(/[^a-z0-9]/gi, ''))) {
            mensagemAlerta('CPF inválido ')
            return
        }
        if (!emailCupum) {
            mensagemAlerta('Digite o email válido ')
            return
        }
        if (!qtdCupum && qtdCupum === 0) {
            mensagemAlerta('Digite o limite de uso dos cupons ')
            return
        }
        if (!valorCupom || valorCupom === 0) {
            mensagemAlerta('Digite o valor do cupom')
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: `Deseja criar o cupom para ${nomeCupom} ? Ele poderá ter apenas 1 cupom por transmissão`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Cadastrando cupom..')
                const data = {
                    nome: nomeCupom,
                    email: emailCupum,
                    qtd: qtdCupum,
                    cpf: cpfCupom.replace(/[^a-z0-9]/gi, ''),
                    valor: parseFloat(valorCupom),
                    idSala: id,
                    tipo: 'transmissao'
                }
                criaCupom(data).then((res) => {
                    if (res.erro) {
                        mensagemAlerta(res.msg)
                    } else {
                        mensagemSucessoCupom(res.msg)
                    }
                })
            }
        });
    }

    function removeCupom(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o cupom ' + item.cupom + ' ? Lembrando que ele será removido da lista de cupons, mas não sairá dos pagamentos',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Removendo cupom...')
                deletaCupom(item.id).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao remover cupom')
                    } else {
                        mensagemSucessoCupom('Cupom removido com sucesso!')
                    }
                })
            }
        });
    }



    function dadosIndicacao() {
        const user = JSON.parse(localStorage.getItem('userd7'));
        return { idUsuario: user?.id, idTransmissao: id };
    }

    async function carregarIndicacoes() {
        setCarregandoIndicacoes(true);
        setErroIndicacoes('');
        try {
            const res = await listaIndicacoes(dadosIndicacao());
            if (res.erro) {
                setErroIndicacoes(res.message);
            } else {
                setIndicacoes(res.indicacoes);
            }
        } catch (error) {
            setErroIndicacoes('Não foi possível carregar os atletas vinculados.');
        } finally {
            setCarregandoIndicacoes(false);
        }
    }

    async function buscaAtletaIndicacao(event) {
        event.preventDefault();
        if (buscandoAtleta || adicionandoAtleta) return;
        setAtletaEncontrado(null);
        const cpfBusca = cpfAtleta.replace(/\D/g, '');
        if (!cpf.isValid(cpfBusca)) {
            setMensagemBuscaAtleta('Digite um CPF válido para buscar o atleta.');
            return;
        }
        setBuscandoAtleta(true);
        setMensagemBuscaAtleta('');
        try {
            const res = await buscaAtletaPorCpf({ ...dadosIndicacao(), cpf: cpfBusca });
            if (res.erro) {
                setMensagemBuscaAtleta(res.message);
            } else {
                setAtletaEncontrado(res.atleta);
            }
        } catch (error) {
            setMensagemBuscaAtleta('Não foi possível buscar o atleta. Tente novamente.');
        } finally {
            setBuscandoAtleta(false);
        }
    }

    async function adicionaAtletaIndicacao() {
        if (!atletaEncontrado || adicionandoAtleta) return;
        setAdicionandoAtleta(true);
        setMensagemBuscaAtleta('');
        try {
            const res = await criaIndicacao({ ...dadosIndicacao(), idAtleta: atletaEncontrado.id });
            setMensagemBuscaAtleta(res.message);
            if (!res.erro) {
                setAtletaEncontrado(null);
                setCpfAtleta('');
                await carregarIndicacoes();
            } else if (res.message === 'Este atleta já está vinculado à transmissão.') {
                await carregarIndicacoes();
            }
        } catch (error) {
            setMensagemBuscaAtleta('Não foi possível adicionar o atleta. Tente novamente.');
        } finally {
            setAdicionandoAtleta(false);
        }
    }

    async function removeAtletaIndicacao(item) {
        if (removendoIndicacao !== null) return;
        setRemovendoIndicacao(item.id);
        try {
            const confirmacao = await Swal.fire({
                title: 'Remover atleta?',
                text: `Tem certeza que deseja remover ${item.nome} desta transmissão? Ele perderá todas as indicações já acumuladas nesta transmissão. Se for adicionado novamente, a contagem começará em zero.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim, remover atleta',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#d33',
                focusCancel: true
            });
            if (!confirmacao.isConfirmed) return;
            const res = await deletaIndicacao(item.id, dadosIndicacao());
            if (res.erro) {
                mensagemErro(res.message);
                return;
            }
            await carregarIndicacoes();
            Swal.fire('Atleta removido', res.message, 'success');
        } catch (error) {
            mensagemErro('Não foi possível remover o atleta. Tente novamente.');
        } finally {
            setRemovendoIndicacao(null);
        }
    }

    // Handlers Academia
    const handleImagem = (event) => {
        event.persist();
        setImagem(event.target.value)
    }
    const handleNomeAcademia = (event) => {
        event.persist();
        setNomeAcademia(event.target.value);
    }
    const handleCanalTransmissao = (event) => {
        event.persist();
        setCanalTransmissao(event.target.value);
    }
    const handleDataTransmissao = (event) => {
        event.persist();
        setDatalTransmissao(event.target.value);
    }
    function handleValor(event, maskedvalue, floatvalue) {
        setValor(maskedvalue);
    }
    const handleStatusAcademia = (event) => {
        event.persist();
        setStatus(event.target.value);
    }
    const handleFree = (event) => {
        event.persist();
        setFree(event.target.value);
    }

    const handleQtdConvidados = (event) => {
        event.persist();
        setQtdConvidados(event.target.value);
    }

    // Sala Vip
    // const handleUsuario = (event) => {
    //     event.persist();
    //     setUsuario(usuarios[event.target.value]);
    // }
    const handleUsuario = (usuario, index) => {
        console.log('Usuário selecionado:', usuario);
        console.log('Index:', index);
        setUsuario(usuario);
    };

    // Cupons
    const handleNomeCupom = (event) => {
        event.persist();
        setNomeCupom(event.target.value);
    }
    const handleCpfCupom = (event) => {
        event.persist();
        setCpfCupom(event.target.value);
    }
    const handleEmailCupom = (event) => {
        event.persist();
        setEmailCupom(event.target.value);
    }
    const handleQtdCupom = (event) => {
        event.persist();
        setQtdCupom(event.target.value);
    }
    function handleValorCupom(event, maskedvalue, floatvalue) {
        setValorCupom(maskedvalue);
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            window.location = '/transmissoes'
        })
    }
    function mensagemSucessoSalaVip(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            setSalaVip([])
            listaSalaVip({ tipo: 'transmissao', id: id }).then((res) => {
                if (res.erro) {
                    mensagemErro('Erro ao buscar sala vip')
                } else {
                    setSalaVip(res)
                }
            })
        })
    }
    function mensagemSucessoCupom(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            setSalaVip([])
            listaCupom(id).then((res) => {
                if (!res.sucesso) {
                    mensagemErro('Erro ao buscar sala vip')
                } else {
                    setListaCupons(res.dados)
                    setNomeCupom('')
                    setCpfCupom('')
                    setEmailCupom('')
                    setValorCupom(0)
                }
            })
        })
    }
    function mensagemLink(msg) {
        Swal.fire('Copie abaixo seu link', msg, 'success')
    }
    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card mb-4">
                                            <div className='row'>
                                                <div className='col-md-10'>
                                                    <h5 className="card-header">{id && nomeAcademia ? nomeAcademia : 'Nova Transmissão'}</h5>
                                                </div>
                                            </div>

                                            {/* Account */}
                                            <div className="card-body">
                                                <div onsubmit="return false">
                                                    <div className="row">
                                                        <div className="card-body row">
                                                            <div className="d-flex align-items-start align-items-sm-center gap-4 col-md-4">
                                                                <img src={imagem ? imagem : 'https://static.vecteezy.com/system/resources/previews/028/047/017/non_2x/3d-check-product-free-png.png'} alt="user-avatar" className="d-block rounded" height={200} width={200} id="uploadedAvatar" />
                                                            </div>
                                                        </div>
                                                        <div className="mb-3 col-md-6">
                                                            <label class="form-label" for="basic-icon-default-fullname">URL da imagem</label>
                                                            <div class="input-group input-group-merge">
                                                                <span id="basic-icon-default-fullname2" class="input-group-text"><i
                                                                    class="bx bx-image"></i></span>
                                                                <input value={imagem} onChange={handleImagem} type="text" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="mb-3 col-md-4">
                                                            <label class="form-label" for="basic-icon-default-fullname">Nome da Transmissão</label>
                                                            <div class="input-group input-group-merge">
                                                                <span id="basic-icon-default-fullname2" class="input-group-text"><i
                                                                    class="bx bx-tv"></i></span>
                                                                <input value={nomeAcademia} onChange={handleNomeAcademia} type="text" class="form-control" />
                                                            </div>
                                                        </div>
                                                        <div class="mb-3 col-md-2" >
                                                            <label class="form-label" for="basic-icon-default-fullname">Valor</label>
                                                            <div class="input-group input-group-merge">
                                                                <span id="basic-icon-default-fullname2" class="input-group-text"><i
                                                                    class="bx bx-money"></i></span>
                                                                {/* <input onChange={handleValor} value={valor} type="text" class="form-control" /> */}
                                                                <CurrencyInput value={valor} onChange={handleValor} className="form-control" id="email2" prefix="R$ " decimalSeparator="," thousandSeparator="." />
                                                            </div>
                                                        </div>
                                                        <div class="mb-3 col-md-3">
                                                            <label class="form-label" for="basic-icon-default-fullname">Canão de Transmissão</label>
                                                            <select id="defaultSelect" className="form-select" onChange={handleCanalTransmissao} >
                                                                <option>Selecione</option>
                                                                <option value={'1'} selected={id && canalTransmissao === '1' ? 'selected' : null} >TvCombate 01</option>
                                                                <option value={'2'} selected={id && canalTransmissao === '2' ? 'selected' : null} >TvCombate 02 </option>
                                                                <option value={'3'} selected={id && canalTransmissao === '3' ? 'selected' : null} >TvCombate 03</option>
                                                                <option value={'4'} selected={id && canalTransmissao === '4' ? 'selected' : null} >TvCombate 04 </option>
                                                            </select>
                                                        </div>
                                                        <div class="mb-3 col-md-3">
                                                            <label class="form-label" for="basic-icon-default-fullname">Data Transmissão</label>
                                                            <input value={dataTransmissao} onChange={handleDataTransmissao} type="datetime-local" class="form-control" />
                                                        </div>
                                                        <div class="mb-3 col-md-2">
                                                            <label class="form-label" for="basic-icon-default-fullname">Status</label>
                                                            <select id="defaultSelect" className="form-select" onChange={handleStatusAcademia} >
                                                                <option>Selecione</option>
                                                                <option value={'ATIVO'} selected={id && status === 'ATIVO' ? 'selected' : null} >Ativo</option>
                                                                <option value={'INATIVO'} selected={id && status === 'INATIVO' ? 'selected' : null} >Inativo </option>
                                                            </select>
                                                        </div>
                                                        <div class="mb-3 col-md-2">
                                                            <label class="form-label" for="basic-icon-default-fullname">Free</label>
                                                            <select id="defaultSelect" className="form-select" onChange={handleFree} >
                                                                <option>Selecione</option>
                                                                <option value={'SIM'} selected={id && free === 'SIM' ? 'selected' : null} >Sim</option>
                                                                <option value={'NAO'} selected={id && free === 'NAO' ? 'selected' : null} >Não </option>
                                                            </select>
                                                        </div>
                                                        <div className="mb-3 col-md-3">
                                                            <label className="form-label" htmlFor="transmissao-indicacoes">Indicações por atleta</label>
                                                            <select id="transmissao-indicacoes" className="form-select" value={indicacoesAtivas ? 'SIM' : 'NAO'} onChange={(event) => setIndicacoesAtivas(event.target.value === 'SIM')}>
                                                                <option value="SIM">Sim</option>
                                                                <option value="NAO">Não</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="mt-2">
                                                        {id ?
                                                            <>
                                                                <button onClick={() => cadastraEvento()} type="submit" className="btn btn-primary me-2">Atualizar Transmissão</button>
                                                            </>
                                                            :
                                                            <button onClick={() => cadastraEvento()} type="submit" className="btn btn-primary me-2">Cadastra Transmissão</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Account */}
                                        </div>
                                        {id ?
                                            <div className="card mb-4">
                                                <div className='row'>
                                                    <div className='col-md-10'>
                                                        <h5 className="card-header">Sala Vip</h5>
                                                    </div>
                                                </div>

                                                {/* Account */}
                                                <div className="card-body">
                                                    <div onsubmit="return false">
                                                        <div className="row">
                                                            <div class="mb-3 col-md-6">
                                                                <label class="form-label" for="basic-icon-default-fullname">Usuários</label>
                                                                {/* <select id="defaultSelect" className="form-select" onChange={handleUsuario} >
                                                                    <option>Selecione</option>
                                                                    {usuarios.map((u, index) =>
                                                                        <option key={u.id} value={index}>{u.nome} - {u.cpf}</option>
                                                                    )}
                                                                </select> */}
                                                                <UsuarioSelect
                                                                    usuarios={usuarios}
                                                                    handleUsuarioSelecionado={handleUsuario}
                                                                />
                                                            </div>
                                                            <div class="mb-3 col-md-2">
                                                                <label class="form-label" for="basic-icon-default-fullname">Qtd. Convidados</label>
                                                                <input value={qtdConvidados} onChange={handleQtdConvidados} type="number" class="form-control" />
                                                            </div>
                                                            <div class="mb-3 col-md-3" style={{ marginTop: 30 }}>
                                                                <button onClick={() => cadastraSala()} type="submit" className="btn btn-primary me-2">Adicionar</button>
                                                            </div>
                                                        </div>
                                                        <div className="table-responsive text-nowrap">
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Usuário</th>
                                                                        <th>CPF</th>
                                                                        <th>Email</th>
                                                                        <th>Qtd Convidados</th>
                                                                        <th>Remover</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="table-border-bottom-0">
                                                                    {salaVip.map((sala) =>
                                                                        <tr key={sala.id}>
                                                                            <td>{sala.usuarioNome}</td>
                                                                            <td>{sala.usuarioCpf}</td>
                                                                            <td>{sala.usuarioEmail}</td>
                                                                            <td>{sala.qtdConvidados}</td>
                                                                            <td>
                                                                                <button onClick={() => removeSala(sala)} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                                    <span className="tf-icons bx bx-trash" />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {salaVip.length === 0 ?
                                                                        <p style={{ textAlign: 'center', padding: 10 }} >Sem usuarios na sala vip</p>
                                                                        :
                                                                        null
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* /Account */}
                                            </div>
                                            :
                                            null
                                        }
                                        {id ?
                                            <div className="card mb-4">
                                                <div className='row'>
                                                    <div className='col-md-10'>
                                                        <h5 className="card-header">Cupons de Desconto</h5>
                                                        <p className="px-4 mb-0">O cupom, serve para que usuários possam ter desconto na hora de comprarem a transmissão</p>
                                                    </div>
                                                </div>

                                                {/* Account */}
                                                <div className="card-body">
                                                    <div onsubmit="return false">
                                                        <div className="row">
                                                            <div class="mb-3 col-md-4">
                                                                <label class="form-label" for="basic-icon-default-fullname">Nome</label>
                                                                <input value={nomeCupom} onChange={handleNomeCupom} type="text" class="form-control" />
                                                            </div>
                                                            <div class="mb-3 col-md-2">
                                                                <label class="form-label" for="basic-icon-default-fullname">CPF</label>
                                                                <input value={cpfCupom} onChange={handleCpfCupom} type="text" class="form-control" />
                                                            </div>
                                                            <div class="mb-3 col-md-3">
                                                                <label class="form-label" for="basic-icon-default-fullname">Email</label>
                                                                <input value={emailCupum} onChange={handleEmailCupom} type="text" class="form-control" />
                                                            </div>
                                                            <div class="mb-3 col-md-1">
                                                                <label class="form-label" for="basic-icon-default-fullname">QTD</label>
                                                                <input value={qtdCupum} onChange={handleQtdCupom} type="number" class="form-control" />
                                                            </div>
                                                            <div class="mb-3 col-md-2">
                                                                <label class="form-label" for="basic-icon-default-fullname">Valor do Cupom</label>
                                                                <CurrencyInput value={valorCupom} onChange={handleValorCupom} className="form-control" id="email2" prefix="R$ " decimalSeparator="," thousandSeparator="." />
                                                            </div>
                                                            <div class="mb-3 col-md-3" style={{ marginTop: 30 }}>
                                                                <button onClick={() => cadastraCupom()} type="submit" className="btn btn-primary me-2">Adicionar</button>
                                                            </div>
                                                        </div>
                                                        <div className="table-responsive text-nowrap">
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Cupom</th>
                                                                        <th>Nome</th>
                                                                        <th>CPF</th>
                                                                        <th>Valor</th>
                                                                        <th>Pagamentos</th>
                                                                        <th>Qtd</th>
                                                                        <th>Usados</th>
                                                                        <th>Total</th>
                                                                        <th>Remover</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="table-border-bottom-0">
                                                                    {listaCupons.map((cupom) =>
                                                                        <tr key={cupom.id}>
                                                                            <td>{cupom.cupom}</td>
                                                                            <td>{cupom.nome}</td>
                                                                            <td>{cupom.cpf}</td>
                                                                            <td>R$ {cupom.valorCupom}</td>
                                                                            <td>{cupom.qtdPagamentos}</td>
                                                                            <td>{cupom.qtd}</td>
                                                                            <td>{cupom.usados}</td>
                                                                            <td>R$ {cupom.valorTotalCupom}</td>
                                                                            <td>
                                                                                <button onClick={() => removeCupom(cupom)} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                                    <span className="tf-icons bx bx-trash" />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {listaCupons.length === 0 ?
                                                                        <p style={{ textAlign: 'center', padding: 10 }} >Sem cupons cadastrados</p>
                                                                        :
                                                                        null
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* /Account */}
                                            </div>
                                            :
                                            null
                                        }


                                        {id ?
                                            <div className="card mb-4">
                                                <h5 className="card-header">Indicações por atleta</h5>
                                                <div className="card-body">
                                                    <p className="mb-4">Vincule atletas à transmissão para acompanhar as indicações que eles fazem do seu evento. Busque pelo CPF de um atleta cadastrado para começar.</p>
                                                    <form onSubmit={buscaAtletaIndicacao}>
                                                        <div className="row align-items-end">
                                                            <div className="mb-3 col-md-4">
                                                                <label htmlFor="cpf-atleta-indicacao" className="form-label">CPF do atleta</label>
                                                                <InputMask
                                                                    id="cpf-atleta-indicacao"
                                                                    name="cpfAtleta"
                                                                    type="text"
                                                                    inputMode="numeric"
                                                                    mask="999.999.999-99"
                                                                    maskChar={null}
                                                                    className="form-control"
                                                                    placeholder="000.000.000-00"
                                                                    value={cpfAtleta}
                                                                    disabled={buscandoAtleta || adicionandoAtleta}
                                                                    onChange={(event) => {
                                                                        setCpfAtleta(event.target.value);
                                                                        setAtletaEncontrado(null);
                                                                        setMensagemBuscaAtleta('');
                                                                    }}
                                                                    aria-describedby={mensagemBuscaAtleta ? 'mensagem-busca-atleta' : undefined}
                                                                />
                                                            </div>
                                                            <div className="mb-3 col-md-auto">
                                                                <button type="submit" className="btn btn-primary" disabled={buscandoAtleta || adicionandoAtleta}>{buscandoAtleta ? 'Buscando...' : 'Buscar'}</button>
                                                            </div>
                                                        </div>
                                                        {mensagemBuscaAtleta &&
                                                            <p id="mensagem-busca-atleta" className="mb-0" role="status">{mensagemBuscaAtleta}</p>
                                                        }
                                                    </form>
                                                    {atletaEncontrado &&
                                                        <div className="border rounded p-3 mt-3">
                                                            <p className="mb-1"><strong>{atletaEncontrado.nome}</strong></p>
                                                            <p className="mb-1">CPF: {atletaEncontrado.cpf}</p>
                                                            <p className="mb-3">Email: {atletaEncontrado.email}</p>
                                                            <button type="button" className="btn btn-primary" onClick={adicionaAtletaIndicacao} disabled={adicionandoAtleta || indicacoes.some((item) => Number(item.id_atleta) === Number(atletaEncontrado.id))}>
                                                                {adicionandoAtleta ? 'Adicionando...' : indicacoes.some((item) => Number(item.id_atleta) === Number(atletaEncontrado.id)) ? 'Atleta já vinculado' : 'Adicionar à transmissão'}
                                                            </button>
                                                        </div>
                                                    }
                                                    <h6 className="mt-4">Atletas vinculados</h6>
                                                    {carregandoIndicacoes ?
                                                        <p role="status">Carregando atletas...</p>
                                                        : erroIndicacoes ?
                                                            <div role="alert">
                                                                <p>{erroIndicacoes}</p>
                                                                <button type="button" className="btn btn-outline-primary" onClick={carregarIndicacoes}>Tentar novamente</button>
                                                            </div>
                                                            : indicacoes.length === 0 ?
                                                                <p className="mb-0">Nenhum atleta vinculado à transmissão.</p>
                                                                : <div className="table-responsive">
                                                                    <table className="table">
                                                                        <thead><tr><th>Nome</th><th>CPF</th><th>Email</th><th>Qtd. indicações</th><th>Remover</th></tr></thead>
                                                                        <tbody>
                                                                            {indicacoes.map((item) =>
                                                                                <tr key={item.id}>
                                                                                    <td>{item.nome}</td>
                                                                                    <td>{item.cpf}</td>
                                                                                    <td>{item.email}</td>
                                                                                    <td>{item.qtd ?? 0}</td>
                                                                                    <td>
                                                                                        <button type="button" className="btn rounded-pill btn-icon btn-danger" aria-label={`Remover ${item.nome} das indicações`} onClick={() => removeAtletaIndicacao(item)} disabled={removendoIndicacao !== null || adicionandoAtleta}>
                                                                                            <span className="tf-icons bx bx-trash" aria-hidden="true" />
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                    }
                                                </div>
                                            </div>
                                            : null
                                        }

                                    </div>

                                </div>
                            </div>


                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}
